import React from 'react'
import {MenuLink} from '@src/modules/Layout/shared/MenuLink'
import {USERS_ROUTES} from '../../constants'
import {Badge, Icon} from '@therms/atalaya'
import {
  Alerts,
  RPCDocs,
  RPCs,
  useRPC,
  useRPCServerEventHandler,
} from '@therms/react-modules'
import {useCurrentOnDutyCounts} from '@src/modules/Users/shared/hooks/useCurrentOnDutyCounts'
import {FaUsers} from 'react-icons/fa'
import {MdEmergency} from 'react-icons/md'

function UsersMenuLink() {
  const {counts} = useCurrentOnDutyCounts()

  const {call, data} = useRPC<
    RPCDocs.UserSos.GetActivatedUserSos.v1.Args,
    RPCDocs.UserSos.GetActivatedUserSos.v1.Data
  >(RPCs.UserSos.GetActivatedUserSos.v1)

  useRPCServerEventHandler('UserSOSActivated', () => {
    if (data?.total) {
      Alerts.error('EMERGENCY S.O.S. ACTIVATED', undefined, {
        toastId: 'emesosactivate',
      })
    }

    call()
  })
  useRPCServerEventHandler('UserSOSActivationUpdated', () => {
    Alerts.info('Emergency S.O.S. details updated', {
      toastId: 'emersosupdate',
    })

    call()
  })

  return (
    <MenuLink
      className={data?.total ? 'bg-critical-faded animate-pulse' : ''}
      to={USERS_ROUTES.__ROOT__}
    >
      <div className="flex w-full items-center justify-between">
        <div className="gap-x-sm inline-flex items-center">
          <Icon Icon={FaUsers} />

          <span>Roster</span>
        </div>

        <div className="flex">
          {!!data?.total && <Icon color="critical" Icon={MdEmergency} />}

          {!!counts && <Badge value={counts} variant="main" />}
        </div>
      </div>
    </MenuLink>
  )
}

export {UsersMenuLink}